var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98876 4.88204L4.24409 8.62671L4.06809 10.5974L6.05276 10.4167L9.78609 6.67937L7.98876 4.88204ZM11.9774 4.48604L10.1808 2.69004L8.88209 3.98871L10.6788 5.78604L11.9774 4.48604ZM3.39409 11.9974C3.37343 11.9994 3.35343 12 3.33343 12C3.15743 12 2.98743 11.9307 2.86209 11.8047C2.72209 11.6647 2.65143 11.47 2.66943 11.2734L2.92209 8.49271C2.95009 8.18804 3.08476 7.90071 3.30143 7.68404L9.29876 1.68604C9.76676 1.21671 10.6161 1.24004 11.1094 1.73271L12.9348 3.55804H12.9354C13.4461 4.06937 13.4661 4.88071 12.9808 5.36737L6.98276 11.3654C6.76609 11.5827 6.47943 11.7167 6.17409 11.7447L3.39409 11.9974ZM3.33329 13.3334H12.6666C13.0333 13.3334 13.3333 13.6334 13.3333 14.0001C13.3333 14.3668 13.0333 14.6668 12.6666 14.6668H3.33329C2.96663 14.6668 2.66663 14.3668 2.66663 14.0001C2.66663 13.6334 2.96663 13.3334 3.33329 13.3334Z",
    fill: "#949494"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_559_18024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 12,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98876 4.88204L4.24409 8.62671L4.06809 10.5974L6.05276 10.4167L9.78609 6.67937L7.98876 4.88204ZM11.9774 4.48604L10.1808 2.69004L8.88209 3.98871L10.6788 5.78604L11.9774 4.48604ZM3.39409 11.9974C3.37343 11.9994 3.35343 12 3.33343 12C3.15743 12 2.98743 11.9307 2.86209 11.8047C2.72209 11.6647 2.65143 11.47 2.66943 11.2734L2.92209 8.49271C2.95009 8.18804 3.08476 7.90071 3.30143 7.68404L9.29876 1.68604C9.76676 1.21671 10.6161 1.24004 11.1094 1.73271L12.9348 3.55804H12.9354C13.4461 4.06937 13.4661 4.88071 12.9808 5.36737L6.98276 11.3654C6.76609 11.5827 6.47943 11.7167 6.17409 11.7447L3.39409 11.9974ZM3.33329 13.3334H12.6666C13.0333 13.3334 13.3333 13.6334 13.3333 14.0001C13.3333 14.3668 13.0333 14.6668 12.6666 14.6668H3.33329C2.96663 14.6668 2.66663 14.3668 2.66663 14.0001C2.66663 13.6334 2.96663 13.3334 3.33329 13.3334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_559_18024)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd436d35c371b5dd29f1438486d467cd.svg";
export { ForwardRef as ReactComponent };